<app-doc-viewer
  title="Layer"
  subtitle="Geo"
  [dependencies]="['LanguageService']"
>
  <app-example-viewer codeFolder="geo/layer">
    <mat-grid-list cols="2" rowHeight="600px" gutterSize="16px">
      <mat-grid-tile>
        <igo-map-browser [map]="map" [view]="view">
          <div class="map-actions --vertical --bottom --right">
            <igo-zoom-button [map]="map" color="primary" />
          </div>
        </igo-map-browser>
      </mat-grid-tile>
      <mat-grid-tile>
        <div class="flex align-start h-100 w-100">
          <igo-panel title="Layers" class="w-100">
            <igo-layer-viewer [map]="map" [options]="layerViewerOptions">
              <ng-template #customBottomActions let-layer="layer">
                <igo-metadata-button [layer]="layer" />
                <igo-download-button [layer]="layer" />
                <igo-ogc-filter-button [header]="true" [layer]="layer" />
                <igo-time-filter-button [header]="true" [layer]="layer" />
                <igo-track-feature-button [layer]="layer" />
                <igo-track-feature-button
                  [layer]="layer"
                  [trackFeature]="true"
                />
              </ng-template>
            </igo-layer-viewer>
          </igo-panel>
        </div>
      </mat-grid-tile>
    </mat-grid-list>
  </app-example-viewer>
</app-doc-viewer>
